var map = {
	"./Accessory.js": 646537,
	"./Bag.js": 7797,
	"./Book.js": 660010,
	"./Clothing.js": 884039,
	"./DeviceCase.js": 714085,
	"./Embroidery.js": 737359,
	"./HomeDecor.js": 601871,
	"./Material.js": 161878,
	"./Scarf.js": 342702,
	"./Stationery.js": 155973,
	"./WallArt.js": 118278,
	"create/ProductCategories/Accessory.js": 646537,
	"create/ProductCategories/Bag.js": 7797,
	"create/ProductCategories/Book.js": 660010,
	"create/ProductCategories/Clothing.js": 884039,
	"create/ProductCategories/DeviceCase.js": 714085,
	"create/ProductCategories/Embroidery.js": 737359,
	"create/ProductCategories/HomeDecor.js": 601871,
	"create/ProductCategories/Material.js": 161878,
	"create/ProductCategories/Scarf.js": 342702,
	"create/ProductCategories/Stationery.js": 155973,
	"create/ProductCategories/WallArt.js": 118278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 965202;